import { AppState, CountryProfileFilters } from '../types';

export const initialState: AppState = {
    dataReady: false,
    countryProfiles: [],
    taxonomies: {
        dates: [],
        countries: [],
        typesOfQuota: [],
        sanctions: [],
        electoralSystemTypes: [],
        rankingPlacement: [],
        legalSources: [],
        regions: [],
        quotaForInputOnly: [],
        parliamentStructure: [],
        quotaTargetMet: [],
        provisionsOnGenderQuotas_yesNo: []
    },
    pages: []
};

export const initialFilters: CountryProfileFilters = {
    countryIds: [],
    typeOfQuotaIds: [],
    electoralSystemIds: [],
    legalSourcesIds: [],
    regionIds: [],
    date: null,
    datetime: null,
    localLevel: false,
};
